import React from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Link from '@mui/material/Link';

export default function ComplementPersonConsult() {
    const numero = "5516994653317";

    const corpo = encodeURIComponent(
        `Olá! Tenho interesse nas vagas de sua empresa, poderia me dar mais detalhes?`
    );
    const whatsappUrl = `https://wa.me/${numero}?text=${corpo}`;
    const instaAppUrl = `https://www.instagram.com/reconect.consultoria/`;
    const linkedinAppUrl = `https://www.linkedin.com/company/reconect-consultoria/`;
    const locationUrl = `https://www.google.com/maps/place/Franca,+SP,+Brasil/`;

    return( 
        <>
            <div className="info-row" style={{ justifyContent: "space-around" }}>
                <span className="bullet" style={{ float: "left"}}>
                    <Link href={ instaAppUrl } underline="hover" target="_blank">
                        <InstagramIcon style={{ color: "orangered" }} /> @reconect.consultoria
                    </Link>
                </span>
                <span className="bullet" style={{ float: "left" }}>
                    <Link href={ whatsappUrl } underline="hover" target="_blank">
                        <WhatsAppIcon style={{ color: "green" }} /> (16) 99465-3317 - Empresarial (RH)
                    </Link>
                </span>
                <span className="bullet" style={{ float: "left" }}>
                    <Link href={ linkedinAppUrl } underline="hover" target="_blank">
                        <LinkedInIcon color="primary" /> @reconect-consultoria 
                    </Link>
                </span>
                <span className="bullet" style={{ float: "left" }}>
                    <Link href={ locationUrl } underline="hover" target="_blank">
                        <LocationOnIcon style={{ color: "red" }} /> Franca - São Paulo, Brasil 
                    </Link>
                </span>
            </div>  
        </>
    );
}
